import React from 'react'

const LinkOut = ({href, className, style, children}) => (
  <a href={href} className={className} style={style} target="_blank" rel="noopener noreferrer">{children}</a>
)

export default LinkOut
